import { render, staticRenderFns } from "./PageBlocks.vue?vue&type=template&id=74d1fcea"
import script from "./PageBlocks.vue?vue&type=script&lang=js"
export * from "./PageBlocks.vue?vue&type=script&lang=js"
import style0 from "./PageBlocks.vue?vue&type=style&index=0&id=74d1fcea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports